export class FrtBookShipmentAccessorialMsgs {
        public frtAccrlsIdMsgId: number;
        public shipmentAccrlsId: number;
        public message: string = "";
  
}